import { put, take, fork } from 'redux-saga/effects';
import { setLoading as setLoadingAction } from '../actions/loading';
import toastDefaults from '../../utils/toastDefaults';

export function * setLoading(loading) {
  yield put(setLoadingAction(loading));
}

export function * watchStopLoading() {
  while (true) { // eslint-disable-line no-constant-condition, no-loops/no-loops
    const { payload } = yield take(action => /(_FAILURE|_SUCCESS)$/.test(action.type));
    const blockLoading = !(payload && typeof payload === 'object' && 'continueLoading' in payload);
    if (blockLoading) {
      yield fork(setLoading, false);
    }
  }
}

export function * displayToastError(payload) {
  let toastText = toastDefaults.errorText;
  // console.log(payload);
  if (payload.type !== 'LOGIN_FAILURE') {
    window.Materialize.toast(toastText, toastDefaults.displayTime);
  }
}

export function * watchStartLoading() {
  while (true) { // eslint-disable-line no-constant-condition, no-loops/no-loops
    yield take(action => /_REQUEST$/.test(action.type));
    yield fork(setLoading, true);
  }
}

export function * watchErrorResult() {
  while (true) { // eslint-disable-line no-constant-condition, no-loops/no-loops
    const payload = yield take(action => /_FAILURE$/.test(action.type));
    yield fork(displayToastError, payload);
  }
}

export default [
  fork(watchStopLoading),
  fork(watchErrorResult),
  fork(watchStartLoading),
];
